<template>
  <div id="app">
    <BlackGoldToastHost />
    <router-view />
  </div>
</template>

<script>
import BlackGoldToastHost from '@/components/common/BlackGoldToastHost.vue'
import { applySiteDocumentTitle } from '@/utils/siteBrand'
import { applyLocaleFromSiteCurrency } from '@/utils/locale'

export default {
  name: 'App',
  components: {
    BlackGoldToastHost
  },
  watch: {
    '$store.state.siteInfo' (siteInfo) {
      applySiteDocumentTitle(siteInfo)
      applyLocaleFromSiteCurrency(siteInfo)
    }
  }
}
</script>
